import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Chip } from "@mui/material";
import { getConversations } from "../api/adminApi";

const STATUS_COLORS = { active: "#10b981", closed: "#6366f1", live_requested: "#f59e0b" };

const InstagramConversations = () => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLoading(true);
    getConversations({ page, limit: 50, platform: "instagram" }).then((data) => {
      setConversations(data.conversations || []);
      setTotal(data.total || 0);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [page]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography fontWeight={800} fontSize={24} color="#1e293b">Instagram Conversations</Typography>
          <Typography variant="body2" color="#64748b">{total} total conversations</Typography>
        </Box>
      </Box>

      <Paper className="glass-card" sx={{ overflow: "hidden" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "#64748b", fontWeight: 700, fontSize: 12, textTransform: "uppercase", borderColor: "#e2e8f0" }}>User</TableCell>
                <TableCell sx={{ color: "#64748b", fontWeight: 700, fontSize: 12, textTransform: "uppercase", borderColor: "#e2e8f0" }}>Bot</TableCell>
                <TableCell sx={{ color: "#64748b", fontWeight: 700, fontSize: 12, textTransform: "uppercase", borderColor: "#e2e8f0" }}>Status</TableCell>
                <TableCell sx={{ color: "#64748b", fontWeight: 700, fontSize: 12, textTransform: "uppercase", borderColor: "#e2e8f0" }}>Messages</TableCell>
                <TableCell sx={{ color: "#64748b", fontWeight: 700, fontSize: 12, textTransform: "uppercase", borderColor: "#e2e8f0" }}>Last Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4, borderColor: "#e2e8f0" }}><CircularProgress /></TableCell></TableRow>
              ) : conversations.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4, color: "#64748b", borderColor: "#e2e8f0" }}>No conversations yet</TableCell></TableRow>
              ) : conversations.map((c) => (
                <TableRow key={c._id} hover sx={{ "&:hover": { bgcolor: "#f8faff" }, "&:last-child td": { border: 0 } }}>
                  <TableCell sx={{ borderColor: "#e2e8f0" }}>
                    <Typography fontWeight={600} fontSize={14} color="#1e293b">{c.userName || "Anonymous"}</Typography>
                    <Typography variant="caption" color="#64748b">ID: {c.sessionId?.slice(0, 12)}...</Typography>
                  </TableCell>
                  <TableCell sx={{ borderColor: "#e2e8f0" }}><Typography variant="body2" color="#475569">{c.botName || "Unknown"}</Typography></TableCell>
                  <TableCell sx={{ borderColor: "#e2e8f0" }}>
                    <Chip label={c.status?.replace("_", " ")} size="small"
                      sx={{ textTransform: "capitalize", fontWeight: 600, fontSize: 12, bgcolor: `${STATUS_COLORS[c.status] || "#64748b"}12`, color: STATUS_COLORS[c.status] || "#64748b", borderRadius: 1 }} />
                  </TableCell>
                  <TableCell sx={{ borderColor: "#e2e8f0" }}><Typography variant="body2" color="#475569">{c.messageCount}</Typography></TableCell>
                  <TableCell sx={{ borderColor: "#e2e8f0" }}><Typography variant="body2" color="#64748b">{new Date(c.updatedAt).toLocaleString()}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {total > 50 && (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2 }}>
          <Chip label="Previous" disabled={page === 1} onClick={() => setPage((p) => Math.max(1, p - 1))}
            sx={{ color: "#1e293b", bgcolor: "#ffffff", border: "1px solid #e2e8f0", "&.Mui-disabled": { opacity: 0.3 } }} />
          <Chip label={`Page ${page} of ${Math.ceil(total / 50)}`} sx={{ color: "#64748b", bgcolor: "#ffffff", border: "1px solid #e2e8f0" }} />
          <Chip label="Next" disabled={page >= Math.ceil(total / 50)} onClick={() => setPage((p) => p + 1)}
            sx={{ color: "#1e293b", bgcolor: "#ffffff", border: "1px solid #e2e8f0", "&.Mui-disabled": { opacity: 0.3 } }} />
        </Box>
      )}
    </Box>
  );
};

export default InstagramConversations;
